import { fuzzyInputSearch } from '../../../pages/deals/helpers/determineDealsActionModalMessage';

export const filterDealBy = ({ title }: any, query: any) => {
  if (!query.length) {
    return true;
  }
  return fuzzyInputSearch({ searchValue: title, filteredText: query });
};
